module.exports = __webpack_public_path__ + "Roboto-regular.f94d5e5102359961c44a.woff";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src590146077/src/src/assets/fonts/roboto/fonts/Roboto-regular/Roboto-regular.woff
// module id = ../../../../../src/assets/fonts/roboto/fonts/Roboto-regular/Roboto-regular.woff
// module chunks = main styles